export default __webpack_public_path__ + "static/media/ethereum.c729bd46.svg";